import React, { Component } from 'react';
import ResultAnalysisSubMenuBar from './ResultAnalysisSubMenuBar';
import Pagination from "react-js-pagination";
import './RAPriceWidget.css'
import RAPriceBox from './Components/RAPriceBox';
import RAEstimateBox from './Components/RAEstimateBox';
import RACorpInfoBox from './Components/RACorpInfoBox';

export default class RAPriceWidget extends Component {
    genTableBox = (section) => {
        let result = [];
        for (let i=0; i<this.props.data.data.length; i++) {
            if(i==10){
                break;
            }
            if (section==="price") {
                result.push(<RAPriceBox token={this.props.token} appId={this.props.appId} ric={this.props.data.data[i].ric} type={this.props.subsection} />);
            } else if (section==="estimate") {
                result.push(<RAEstimateBox token={this.props.token} appId={this.props.appId} ric={this.props.data.data[i].ric} type={this.props.subsection} />);
            } else if (section==="corpinfo") {
                result.push(<RACorpInfoBox token={this.props.token} appId={this.props.appId} num={i} ric={this.props.data.data[i].ric} type={this.props.subsection} stockinfo={this.props.data.data[i]}  handleCompInfoPopupChange={this.props.handleCompInfoPopupChange}/>);
            }
        }
        return result;
    }
    handlePageChange = (pageno) => {
        this.props.onPageChange(pageno);
    }
    handleMenuChange = (subsection) => {
        this.props.onSubSectionChange(subsection);
    }
   
    render() {
        const { subsection } = this.props;
        return (
            this.props.data.count>0? <div className="RAPriceWidget">
                <ResultAnalysisSubMenuBar section={this.props.section} subsection={subsection} onMenuChange={this.handleMenuChange} />
                
                <div className="updateinfo">最終更新日時：{this.props.data.update}</div>
                <div className="paging">
                    <Pagination
                        activePage={this.props.pageno}
                        itemsCountPerPage={this.props.recperpage}
                        totalItemsCount={this.props.data.count}
                        pageRangeDisplayed={5}
                        onChange={this.handlePageChange}
                        prevPageText="前へ"
                        nextPageText="次へ"
                        firstPageText="最初へ"
                        lastPageText="最後へ"
                    />
                </div>
                <div style={{clear: 'both'}} />
                <div className='tableBox' >
                { this.genTableBox(this.props.section) }
                </div>
                <div style={{clear: 'both'}} />
                <div className="paging">
                    <Pagination
                        activePage={this.props.pageno}
                        itemsCountPerPage={this.props.recperpage}
                        totalItemsCount={this.props.data.count}
                        pageRangeDisplayed={5}
                        onChange={this.handlePageChange}
                        prevPageText="前へ"
                        nextPageText="次へ"
                        firstPageText="最初へ"
                        lastPageText="最後へ"
                    />
                </div>
            </div>:<div className="noStockMsg">該当する銘柄はありません。</div>
        )
    };
}